var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"mb-10",attrs:{"rounded":""}},[_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.text)}})],1),_c('MediaTabs',{attrs:{"items":_vm.mediaGroups}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }